import axios, { AxiosResponse } from 'axios';
import { apiClient } from '../../apiClient';

export interface FormType {
    _id: string;
    designation: string;
    description?: string;
    color?: string;
    crudStatus: number;
    createdAt?: string;
    updatedAt?: string;
}

export interface FormTypesResponse {
    message: string;
    data: FormType[];
}

export interface FormTypeResponse {
    message: string;
    data: FormType;
}

export interface CreateFormTypeBody {
    designation: string;
    description?: string;
    color?: string;
    crudStatus?: number;
}

export interface UpdateFormTypeBody {
    designation?: string;
    description?: string;
    crudStatus?: number;
    color?: string;
}

export interface GetAllFormTypeQueries {
    active?: boolean;
}

// GET ALL
export const getAllFormTypes = async (queries?: GetAllFormTypeQueries): Promise<FormTypesResponse> => {
    try {
        const response: AxiosResponse<FormTypesResponse> = await apiClient.get('/form-types', { params: queries });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) throw new Error(error.response.data.message);
        throw new Error('An unexpected error occurred');
    }
};

// CREATE
export const createFormType = async (data: CreateFormTypeBody): Promise<FormTypeResponse> => {
    try {
        const response: AxiosResponse<FormTypeResponse> = await apiClient.post('/form-types', data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) throw new Error(error.response.data.message);
        throw new Error('An unexpected error occurred');
    }
};

// UPDATE
export const updateFormType = async (id: string, data: UpdateFormTypeBody): Promise<FormTypeResponse> => {
    try {
        const response: AxiosResponse<FormTypeResponse> = await apiClient.patch(`/form-types/${id}`, data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) throw new Error(error.response.data.message);
        throw new Error('An unexpected error occurred');
    }
};

// DELETE / DEACTIVATE
export const deleteFormType = async (id: string): Promise<{ message: string }> => {
    try {
        const response: AxiosResponse<{ message: string }> = await apiClient.delete(`/form-types/${id}`);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) throw new Error(error.response.data.message);
        throw new Error('An unexpected error occurred');
    }
};
